import api from '../..';

export default ({
  code,
  fio,
  serial,
  number,
}) => {
  let url = '/tourclient/api/orderapi/GetOne?';
  if (code) {
    url += `OrderCode=${encodeURIComponent(code)}&`;
  }
  if (fio) {
    url += `TouristName=${encodeURIComponent(fio.name)
    }&TouristFirstName=${encodeURIComponent(fio.firstName)
    }&TouristPatronymic=${encodeURIComponent(fio.middleName)}&`;
  }
  if (serial && number) {
    url += `PassportSeria=${encodeURIComponent(serial)
    }&PassportNumber=${encodeURIComponent(number)}&`;
  }
  url += 'IsStrongSearchByCode=true';
  return api.get(url, { formatting: true })
    .then(data => data.item);
};



